export default function BlankChart() {

    return (
        <div className="blank-chart">
            <h2>Specify chart options to begin</h2>
        </div>
    )
}